export function daysAgo(iso: string | null | undefined): string {
  if (!iso) return "";
  const diff = Date.now() - new Date(iso).getTime();
  const days = Math.floor(diff / 86400000);
  if (days === 0) return "Today";
  if (days === 1) return "1 day ago";
  if (days < 30) return `${days} days ago`;
  const months = Math.floor(days / 30);
  return months === 1 ? "1 month ago" : `${months} months ago`;
}

function ageInDays(iso: string | null | undefined): number | null {
  if (!iso) return null;
  return Math.floor((Date.now() - new Date(iso).getTime()) / 86400000);
}

/** Jobs are never auto-deleted (see docs/integrations/upwork/README.md) — these
 * thresholds only drive a visual "this data may be stale" cue for admins, who can
 * then choose to run the Delete Old Jobs cleanup if/when they want to. */
export function isStale(discoveredAt: string | null | undefined): boolean {
  const days = ageInDays(discoveredAt);
  return days !== null && days >= 1;
}

export function isVeryStale(discoveredAt: string | null | undefined): boolean {
  const days = ageInDays(discoveredAt);
  return days !== null && days >= 30;
}
